module.exports = __webpack_public_path__ + "static/media/rugrats-post-game-products-bg.6636fbf3.png";